/**
 * VisualizerPlaceholder — Shown while a ```visualizer code fence is still streaming.
 *
 * Minimal spinner + label, transparent background.
 */

import React from 'react';
import type { VisualizerPlaceholderProps } from './types';

export const VisualizerPlaceholder: React.FC<VisualizerPlaceholderProps> = ({
  label = 'Création de la visualisation…',
}) => (
  <div className="my-6 flex flex-col items-center justify-center gap-3 py-10">
    <div
      className="h-5 w-5 rounded-full border-2 border-grey-200 border-t-grey-600 animate-spin"
    />
    <span className="text-xs text-grey-400 tracking-wide">{label}</span>
  </div>
);
